import { fetchApiData } from "../../utils/apiUtils";
import { ENDPOINT } from "../../constants/api";
import * as billSlice from "../slices/bill.slice";
export const getBill =
  (businessSlug, branchPosSellingId, date, status, branchPosId) =>
  async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "get",
        endpoint: `${ENDPOINT.POS.replace(
          "{businessSlug}",
          businessSlug
        )}/bill`,
        dispatch,
        params: (() => {
          const params = {
            branchPosSellingId: branchPosSellingId,
            date: date,
            status: status,
          };
          if (branchPosId) {
            params.branchPosId = branchPosId;
          }
          return params;
        })(),
      });
      if (data) {
        dispatch(billSlice.clearBillItem());
        dispatch(billSlice.setBillItem(data));
      }
      return data;
    } catch (error) {
      dispatch(billSlice.clearBill());
      return error;
    }
  };

export const getBillCancelRemark = () => async (dispatch) => {
  try {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.BLANK}/bill-cancel-remark/list`,
      dispatch,
    });
    if (data) {
      dispatch(billSlice.clearRemark());
      dispatch(billSlice.setRemark(data));
    }
    return data;
  } catch (error) {
    dispatch(billSlice.clearRemark());
    return error;
  }
};
export const cancelBill = (data, businessSlug, id) => async (dispatch) => {
  try {
    const response = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/bill/${id}/cancel`,
      dispatch,
      data,
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const returnBill = (data, businessSlug) => async (dispatch) => {
  try {
    const response = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/bill/returned`,
      dispatch,
      data,
    });
    return response;
  } catch (error) {
    return null;
  }
};

export const getBillById =
  (businessSlug, id, discountPrice, discountPoint, dismissLoading = false) =>
  async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "get",
        endpoint: `${ENDPOINT.POS.replace(
          "{businessSlug}",
          businessSlug
        )}/bill/${id}`,
        dispatch,
        params: {
          discountPrice: discountPrice,
          discountPoint: discountPoint,
        },
        dismissLoading: dismissLoading,
      });

      if (data) {
        dispatch(billSlice.clearBill());
        dispatch(billSlice.setBill(data));
      }

      return data;
    } catch (error) {
      dispatch(billSlice.clearBill());
      return error;
    }
  };

export const getBillByBranchTableId =
  (businessSlug, id) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "get",
        endpoint: `${ENDPOINT.POS.replace(
          "{businessSlug}",
          businessSlug
        )}/bill/table/${id}`,
        dispatch,
      });

      if (data) {
        return data;
      }
    } catch (error) {
      dispatch(billSlice.clearBill());
      return error;
    }
  };

export const makePayment = (data, businessSlug) => async (dispatch) => {
  try {
    const response = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/payment`,
      dispatch,
      data,
    });
    dispatch(billSlice.setPaymentResponse(response));
    return response;
  } catch (error) {
    console.log("error xxx : ", error);

    return error;
  }
};

export const voidBill = (data, businessSlug, id) => async (dispatch) => {
  try {
    const response = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/bill/${id}/void`,
      dispatch,
      data,
    });
    return response;
  } catch (error) {
    return error;
  }
};
